import React, { SVGProps } from 'react';

export const PencilIcon: React.FC<SVGProps<any>> = ({ fill = '#62707B' }) => {
  return (
    <svg
      fill='none'
      height='35'
      viewBox='0 0 36 35'
      width='36'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M20.6197 7.75531C22.4496 5.92189 25.417 5.9219 27.2468 7.75531C29.0759 9.58795 29.0759 12.5587 27.2468 14.3913L14.5013 27.1615L27.9297 27.1615C28.3324 27.1615 28.6588 27.488 28.6588 27.8907C28.6588 28.2934 28.3324 28.6198 27.9297 28.6198L7.14842 28.6198C6.74571 28.6198 6.41925 28.2934 6.41925 27.8907L6.41925 22.2849C6.41925 22.0917 6.49588 21.9065 6.63232 21.7698L20.6197 7.75531ZM12.4409 27.1615L23.3027 16.2787L18.738 11.7051L7.87758 22.5865L7.87758 27.1615H12.4409ZM19.7682 10.6729L24.3329 15.2465L26.2147 13.3611C27.4756 12.0978 27.4756 10.0489 26.2147 8.78551C24.9545 7.52294 22.912 7.52294 21.6519 8.78551L19.7682 10.6729Z'
        fill={fill}
        fillRule='evenodd'
      />
    </svg>
  );
};
